// extracted by mini-css-extract-plugin
export default {"workflowDiagramLayout":"WorkflowDiagram_workflowDiagramLayout__npvBA"};